export default __webpack_public_path__ + "static/media/yes.2fc0fb9c.png";